/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2023] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
import _ from 'lodash';

import { formatDisplayDate } from '@/util/MomentUtils';
import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetExpiringContractDetails() {
  const response = await $.soap({
    body: {
        GetExpiringContractDetails: {
        $xmlns: 'http://dla.mil/ems/bpm/asset'
      }
    },
    blueprintArrays: [
      'GetExpiringContractDetailsResponse.Response.Notification'
    ],
    blueprint: {
      expiringContracts: [
        'GetExpiringContractDetailsResponse.Response.Notification',
        {
          piinSpiin: '$..PIIN',
          contractVehicle: '$..ContractVehicle',
          contractVehicleName: '$..ContractVehicleName',
          numberDevices: '$..NumberDevices',
          totalValue: '$..TotalValue',
          contractEndDate: '$..ContractEndDate',
          daysUntilContractEnd: '$..DaysUntilContractEnd',
          daysNeededBeforePopDate: '$..DaysNeededBeforePopDate',
          notificationDate: '$..NotificationDate'
        }
      ]
    }
  });

  _.each(response.expiringContracts, (contract) => {
    contract.formattedTotalValue = parseInt(contract.totalValue).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const absoluteValueOfDays = Math.abs(contract.daysUntilContractEnd);

    if (Math.sign(contract.daysUntilContractEnd) === 1) {
      contract.daysUntilContractEndFormatted = `${absoluteValueOfDays} days until contract end`;
    } else {
      contract.daysUntilContractEndFormatted = `${absoluteValueOfDays} days past contract end`;
    }

    if(contract.notificationDate) {
      contract.notificationDate = formatDisplayDate(contract.notificationDate);
    }
  });

  cleanUpResponse(response);
  return response;
}
